const getRanges = (from, to) => {
  let range = {}
  if (from) {
    range.from = [
      ...from
    ]
  }
  if (to) {
    range.to = [
      ...to
    ]
  }
  return range
}
const genderOptions = [
  { text: 'All', value: '' },
  { text: 'Male', value: 'MALE' },
  { text: 'Female', value: 'FEMALE' }
];
const followersCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
const followerOptions = getRanges(followersCount, followersCount)

const ageFromCount = ['13', '18', '25', '35', '45', '65']
const ageToCount = ['17', '24', '34', '44', '64', '65+']
const ageOptions = getRanges(ageFromCount, ageToCount)

const creatorAgeOptions = ['13-17', '18-24', '25-34', '35-44', '45-64', '65+']
const creatorAgePercentOptions = [
  '≥1%',
  '≥5%',
  '≥10%',
  '≥15%',
  '≥20%',
  '≥25%',
  '≥30%',
  '≥35%',
  '≥40%',
  '≥45%',
  '≥50%',
  '≥55%',
  '≥60%',
  '≥65%',
  '≥70%',
  '≥75%',
  '≥80%',
  '≥85%',
  '≥90%',
  '≥95%'
]

const limitOptions = [100, 300, 500, 1000, 2000, 5000, 10000, 'All']

const paidPstPerformanceCount = ['1', '10', '20', '30', '40', '50', '60', '80', '100'];
const paidPstPerformanceOptions = getRanges(paidPstPerformanceCount, paidPstPerformanceCount)

// const engRateCount = ['100', '500', '1K', '5K', '10K', '500K'];
// const engRateOptions = getRanges(engRateCount, engRateCount)
const engRatePercentageCount = ['5.0', '10.0', '15.0', '20.0'];
const engRatePercentageOptions = getRanges(false, engRatePercentageCount)
const imsOptions = [
  { text: 'All Influencers', value: 0 },
  { text: 'IMS Only', value: 1 },
  { text: 'Not in IMS', value: 2 }
];
const imsInfluencerStatus = {
  All: 0,
  IMS: 1,
  NON_IMS: 2
}
const searchFilters = () => {
  return Object.assign({}, {
    gender: '',
    followers: {from: '', to: ''},
    isIMS: imsInfluencerStatus.All,
    infInterest: [],
    audienceInterest: [],
    campaign: '',
    campaignType: '',
    engagements: {from: '', to: ''},
    engagementRate: {to: ''},
    ageGroup: '',
    ageGroupPercent: '',
    secAgeGroup: '',
    secAgeGroupPercent: '',
    limit: 100,
    // ageGroupLimit: 100,
    // countryLimit: 100,
    // audInterestLimit: 100,
    paidPstPerformance: {from: '', to: ''}
  })
}
export default Object.assign(
  {},
  {
    ageOptions,
    creatorAgeOptions,
    creatorAgePercentOptions,
    limitOptions,
    genderOptions,
    followerOptions,
    engRatePercentageOptions,
    paidPstPerformanceOptions,
    imsOptions,
    imsInfluencerStatus,
    searchFilters
  }
)



// WEBPACK FOOTER //
// ./src/components/views/Influencer/searchConfig.js